module App.Services {

    export class EncryptionService implements App.Interfaces.IEncryptionService {
        static serviceId = 'encryptionService';

        // Declare this key and iv values in declaration
        private key = CryptoJS.enc.Utf8.parse(Constants.encryptionKey);
        private iv = CryptoJS.enc.Utf8.parse(Constants.encryptionIV);

        // Methods for the encrypt and decrypt Using AES
        decrypt = (message) => {
            var decrypted = CryptoJS.AES.decrypt(message, this.key, {
                keySize: 128 / 8,
                iv: this.iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
            return decrypted.toString(CryptoJS.enc.Utf8);
        }
    }

    app.service(EncryptionService.serviceId, EncryptionService);
}